module.exports = __webpack_public_path__ + "img/4.7a69c223.jpg";